// extracted by mini-css-extract-plugin
export default {"title":"UnityCanvas_title__SVMQD","canvas_wrapper":"UnityCanvas_canvas_wrapper__3+uai","button_area":"UnityCanvas_button_area__AJbQ-"};